import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { NewlyCreatedPetition } from '../../types';

import { NewlyCreatedPetitionsFromPetitionV2 } from './api.graphql';
import type {
	NewlyCreatedPetitionsFromPetitionV2Query,
	NewlyCreatedPetitionsFromPetitionV2QueryVariables,
} from './api.graphql';

export const MAX_PETITIONS = 4;

type Options = Readonly<{
	petitionSlugOrId?: string;
}>;

export async function getNewlyCreatedPetitions(
	{ petitionSlugOrId }: Options,
	{ gql: { fetch } }: UtilityContext,
): Promise<{ petitions: ReadonlyArray<{ node: NewlyCreatedPetition }>; parentPetitionId?: string }> {
	if (!petitionSlugOrId) return { petitions: [] };
	const { data } = await fetch<
		NewlyCreatedPetitionsFromPetitionV2Query,
		NewlyCreatedPetitionsFromPetitionV2QueryVariables
	>({
		query: NewlyCreatedPetitionsFromPetitionV2,
		variables: {
			petitionSlugOrId,
			count: MAX_PETITIONS,
		},
		// to separate query from other batched queries
		batched: false,
		rejectOnError: true,
	});
	if (!data.petition) {
		throw new Error('petition not found');
	}
	return {
		petitions: data.petition.newlyCreatedPetitionsConnection.edges,
		parentPetitionId: data.petition.id,
	};
}
